"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRedux = require("react-redux");

var _actions = require("../actions");

/**
 * This is a `smart` component. It will remember which *Impression components have
 * been rendered to the screen and seen by the user.
 *
 * *
 * Dependencies
 */
var _default = function _default(ImpressionComponent) {
  var ImpressionState = /*#__PURE__*/function (_Component) {
    (0, _inherits2.default)(ImpressionState, _Component);

    var _super = (0, _createSuper2.default)(ImpressionState);

    function ImpressionState() {
      (0, _classCallCheck2.default)(this, ImpressionState);
      return _super.apply(this, arguments);
    }

    (0, _createClass2.default)(ImpressionState, [{
      key: "componentWillMount",
      value: // eslint-disable-next-line react/no-deprecated
      function componentWillMount() {
        // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        if (!this.props.impressions && process.env.NODE_ENV === 'development') {
          console.error('`impressions` reducer not found. Make sure to' + 'import the reducer and add to your redux store');
        }
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react.default.createElement(ImpressionComponent, this.props);
      }
    }]);
    return ImpressionState;
  }(_react.Component); // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration


  ImpressionState.displayName = 'ImpressionState'; // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration

  ImpressionState.propTypes = {
    id: _propTypes.default.string.isRequired,
    // eslint-disable-next-line react/forbid-prop-types, react/require-default-props -- directive added automatically by Shepherd migration
    impressions: _propTypes.default.object,
    impressionReported: _propTypes.default.func.isRequired,
    hasBeenTracked: _propTypes.default.bool.isRequired
  };
  return (0, _reactRedux.connect)(function (state, ownProps) {
    return {
      hasBeenTracked: !!state.impressions[ownProps.id],
      impressions: state.impressions
    };
  }, function (dispatch, ownProps) {
    return {
      impressionReported: function impressionReported(eventData) {
        return dispatch((0, _actions.impressionReported)(ownProps.id, eventData));
      }
    };
  })(ImpressionState);
};

exports.default = _default;